/*global PRODUCTION  RELEASE angular*/
import 'babel-polyfill';
//ANGULAR MODULES
import agGrid from 'ag-grid-enterprise/dist/ag-grid-enterprise';
import angularUIRouter from '@uirouter/angularjs';
import angularStorage from 'angular-storage';
import ngSanitize from 'angular-sanitize';
import angularTranslate from 'angular-translate';
import smartTable from 'angular-smart-table';
import uiMask from 'angular-ui-mask';
import ngCsv from 'ng-csv';
//UI.Bootstrap
import carousel from 'angular-ui-bootstrap/src/carousel';
import modal from 'angular-ui-bootstrap/src/modal';
import typeahead from 'angular-ui-bootstrap/src/typeahead';
import tooltips from 'angular-ui-bootstrap/src/tooltip';
import tabs from 'angular-ui-bootstrap/src/tabs';
import accordion from 'angular-ui-bootstrap/src/accordion';
import progressbar from 'angular-ui-bootstrap/src/progressbar';
import pagination from 'angular-ui-bootstrap/src/pagination';
import dropdown from 'angular-ui-bootstrap/src/dropdown';
import popover from 'angular-ui-bootstrap/src/popover';
import datePickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import timePicker from 'angular-ui-bootstrap/src/timepicker';
//STANDARD FILES
import routes from './routes';
import controllers from './controllers';
import components from './components';
import directives from './directives';
import services from './services';
import filters from './filters';

//CSS FILES
require('assets/inspinia/index.less');
require('assets/inspinia/plugins/jvectormap/jquery-jvectormap-2.0.2.css');
require('sweetalert2/dist/sweetalert2.min.css');

//Bootstrap
require('angular-ui-bootstrap/dist/ui-bootstrap-csp.css');
require('assets/inspinia/css/morris/morris.css');
require('icheck-bootstrap/icheck-bootstrap.min.css');

//C3 Charts
require('assets/inspinia/css/c3/c3.min.css');

//isteven-angular-multiselect
require('isteven-angular-multiselect/isteven-multi-select.css');

// ladda Buttons
require('assets/inspinia/css/ladda/ladda-themeless.min.css');

require('assets/css/animate.css');
require('assets/inspinia/plugins/staps/jquery.steps.css');

// AngularJS Ui.Calendar
require('fullcalendar/dist/fullcalendar.css');

//summernote
require('summernote/dist/summernote.css');

require('codemirror/mode/htmlembedded/htmlembedded');
require('codemirror/lib/codemirror.css');

// chosen
require('chosen-js/chosen.css');

const modules = [
  angularUIRouter,
  'ngCookies',
  angularStorage,
  'ngFileUpload',
  ngSanitize,
  // ngAnimate,
  carousel,
  modal,
  tooltips,
  typeahead,
  tabs,
  accordion,
  progressbar,
  pagination,
  dropdown,
  datePickerPopup,
  timePicker,
  popover,
  angularTranslate,
  smartTable,
  uiMask,
  ngCsv,
  'agGrid',
  'auth0.auth0',
  'angular-jwt',
  'angular.filter',
  'angular-ladda',
  'angular-clipboard',
  'angular-bind-html-compile',
  'chart.js',
  'gridshore.c3js.chart',
  'isteven-multi-select',
  'pageslide-directive',
  'stripe.checkout',
  'toggle-switch',
  'ui.calendar',
  'ui.checkbox',
  'ui.footable',
  'ui.sortable',
  'bm.uiTour',
  'localytics.directives',
  'summernote',
  controllers,
  components,
  directives,
  services,
  filters
];

// Begin Sentry Loaded from CDN
if (PRODUCTION && typeof Sentry !== 'undefined') {
  Sentry.init({
    attachStacktrace: true,
    debug: true,
    dsn: 'https://c95fcc3eb7e4470abd439f77af53a3c9@o74486.ingest.sentry.io/160616',
    maxBreadcrumbs: 20,
    ignoreErrors: ['offsetHeight', 'interpolateFnWatchAction'],
    integrations: [new Sentry.Integrations.Angular()],
    release: RELEASE,
    tracesSampleRate: 0.2
  });
}
// End Sentry

// if you're using AG Grid Enterprise, you'll need to provide the License Key before doing anything else
// not necessary if you're just using AG Grid
agGrid.LicenseManager.setLicenseKey('your license key goes here');

// get AG Grid to create an Angular module and register the AG Grid directive
agGrid.initialiseAgGridWithAngular1(angular);

export default angular
  .module('app', modules)
  .config(routes)
  .run([
    'AuthClass',
    '$log',
    '$rootScope',
    '$state',
    '$location',
    (AuthClass, $log, $rootScope, $state, $location) => {
      $rootScope.$back = () => window.history.back();

      $rootScope.$on('$locationChangeStart', function(event, next) {
        gtag('event', 'page_view', {
          page_title: $state.current.name,
          page_location: next,
          page_path: $location.path()
        });
      });

      $state.defaultErrorHandler(error => {
        if (error.message === 'The transition has been superseded by a different transition') return;

        if (error.detail !== 'No Token' && error.detail !== 'logout') {
          $log.error('Error Location: ', window.location.href);
          $log.error(error);

          if (PRODUCTION && typeof Sentry !== 'undefined') {
            Sentry.captureException(error);
          }
        }

        window.location = '/';
      });

      $rootScope.$state = $state;
    }
  ]);



// WEBPACK FOOTER //
// ./src/app/index.js